const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
            const elems = [...document.querySelectorAll<HTMLElement>('.j-progress-line')];

            elems.forEach((item: HTMLElement) => {
                let counter = 0;
                // eslint-disable-next-line
                const percent = parseInt(item.dataset['percent'] || '0', 10);

                const frame = (): void => {
                    if (counter >= percent) {
                        clearInterval(main);
                    } else {
                        counter++;
                        const progressBar = item.querySelector<HTMLElement>('.j-progress-bar');
                        const progressPercent = item.querySelector<HTMLElement>('.j-progress-percent');

                        if (progressBar && progressPercent) {
                            progressBar.style.width = `${counter}%`;
                            progressPercent.innerHTML = `${counter}%`;
                        }
                    }
                };

                const main = setInterval(frame, 100);
            });
        }
    });
}, {
    threshold: 0.5
});

const progressLines = document.querySelector<HTMLElement>('.j-progress-lines');

if (progressLines) {
    observer.observe(progressLines);
}

export {};
